<template>
  <footer id="footer" class="footer">
    <div class="logo"><img src="../../../assets/logo.png" alt="" /></div>
    <div class="container wide-style">
      <!-- main footer -->
      <div class="main-footer">
        <div class="row">
          <div class="col-lg-4 col-md-12">
            <!--<div class="widget">
              <h6 class="widget-title">Recibe nuestras noticias</h6>
            </div>-->
          </div>
          <div class="col-lg-4 offset-lg-4 col-md-12">
            <!--<div class="widget">
              <h6 class="widget-title">¡Sigamos en contacto!</h6>
              <ul class="social-icons">
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/DivinorumBotiqueHerbal"
                    ><i class="icon-facebook"></i
                  ></a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/divinorumboutiqueherbal"
                    ><i class="icon-instagram-5"></i
                  ></a>
                </li>
              </ul>
            </div>-->
          </div>
        </div>
      </div>
      <ul class="menu-list">
        <li><a href="https://store.divinorum.com.mx/">Inicio</a></li>
        <li><a href="/aubut_us">¿Quiénes somos?</a></li>
        <li><a href="courses">Cursos y Talleres</a></li>
        <li><a href="/single_page/spa">Servicios</a></li>
        <!-- <li><a href="blog">blog</a></li> -->
        <li><a href="https://store.divinorum.com.mx/tienda/">Tienda en linea</a></li>
        <!--li><a href="#">Productos</a></li-->
      </ul>
      <div class="copyright">
        <p>
          Copyright © 2021 Divinorum. Todos los derechos reservados.
          <a href="https://www.mitikuin.com" target="_blank" rel="noopener noreferrer">Powered by www.mitikuin.com</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.menu-list > li > a {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 300;
  line-height: 1.6;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #fff;
}

.copyright p {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
}
</style>
